import { Component, Input } from '@angular/core';
import { AnnouncementModel } from 'src/app/models/announcement-model';

@Component({
  selector: 'app-announcements-view',
  templateUrl: './announcements-view.component.html',
  styleUrls: ['./announcements-view.component.css']
})
export class AnnouncementsViewComponent {

  @Input() messages: AnnouncementModel[] = [];
}
